module.exports = __webpack_public_path__ + "media/images/team/BrigidaCaiado-cb1e1ce162299cff38a6505a56b7e788.png";